"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Textarea = function (_a) {
    var value = _a.value, onChange = _a.onChange, className = _a.className, disabled = _a.disabled, placeholder = _a.placeholder, maxLength = _a.maxLength;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-textarea", disabled && "disabled", className) },
        react_1.default.createElement("textarea", { value: value, placeholder: placeholder, disabled: disabled, onChange: function (e) { return onChange(e.target.value); }, maxLength: maxLength }),
        maxLength ? (react_1.default.createElement("span", { className: "ui-textarea-char-count" },
            (value === null || value === void 0 ? void 0 : value.length) || 0,
            " / ",
            maxLength)) : null));
};
exports.default = Textarea;
